module.exports = __webpack_public_path__ + "media/images/step-recource--e16aa0886aeb11103a2c1db687cc7562.png";